// launchDarkly.web.ts
import { type UserProfile } from "@/types/userTypes"
import { atom } from "nanostores"

/**
 * Identifies the user with LaunchDarkly.
 * @param userProfile - The user profile object or null if not logged in.
 */
export const identifyWithLaunchDarkly = async (userProfile?: UserProfile) => {
  // This happens in LDProviderWrapper.web.tsx on Web.. Only used on native
}

// Remains null on Web, set to the user's key on native
export const $ldKey = atom<string | null>(null)
export const $ldContextString = atom<string | null>(null)
